export class Property {
  public name: string;
  public value: string;
  constructor(
    name: string,
    value: string) {
    this.name = name;
    this.value = value;
  }
}
